import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { KeyHint } from '@/components/KeyHint';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { useVideoPlayerContext } from './VideoPlayerProvider';

export const VideoZoomLockHint: React.FC = () => {
    const { t } = useTranslation(I18nNamespace.VIDEO);
    const { zoomed, zoomLocked } = useVideoPlayerContext();

    if (!zoomed) return null;

    return (
        <>
            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-[linear-gradient(to_top,rgba(17,18,20,0.6)_0%,rgba(17,18,20,0.25)_32%,rgba(17,18,20,0.07)_65%,transparent_100%)]" />
            <div className="pointer-events-none absolute inset-x-0 bottom-16 text-center text-sm font-medium leading-5 text-white-100">
                <Trans
                    t={t}
                    ns={I18nNamespace.VIDEO}
                    i18nKey={
                        zoomLocked
                            ? 'controls.unlockZoomHint'
                            : 'controls.lockZoomHint'
                    }
                    components={{
                        key: (
                            <KeyHint
                                theme="light"
                                className="mx-0.5 align-middle"
                            >
                                L
                            </KeyHint>
                        ),
                    }}
                />
            </div>
        </>
    );
};
